import { ICountryItem } from "~/types/ICountryItem";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ICountryState {
    country: ICountryItem;
    isLoading: boolean;
    error: string;
}

const initialState: ICountryState = {
    country: { value: 'RU', label: 'Россия', currency: 'RUB' },
    isLoading: false,
    error: ''
}

export const countrySlice = createSlice({
    name: 'country',
    initialState,
    reducers: {
        changeCountry(state, action: PayloadAction<ICountryItem>) {
            state.country = action.payload
        }
    }
})

export default countrySlice.reducer;